module.exports = __webpack_public_path__ + "static/media/view5.262d0691.jpg";